import { useState } from "react";
import { useAuth } from "../../global-components/src";
import { GlobalAccount } from "../../global-components/src/components/global-account";
import { PACOCA_URL, READBOOKS_URL } from "../../global-components/src/utils/vars";
import Modal from "../../global-components/src/components/modal/modal";
import { isMyLove } from "../../global-components/src/utils/auth";
import { BookOpen } from "lucide-react";

export function Share(){
    const { user } = useAuth();
    const shareUrl = `${READBOOKS_URL}/@${user?.user_name}`;
    const [showShare, setShowShare] = useState(false);

    const copyLink = () => {
        navigator.clipboard.writeText(shareUrl);
    };

    return (
        <>
            <Modal
                textBtnConfirmar="Ok"
                idModal="modal-share"
                onOpen={copyLink}
                coverMobile={false}
                onClose={() => setShowShare(false)}
                title={`Link copiado${isMyLove(user) ? ", meu amor" : ""}!`} 
                text={`O link do livro foi copiado${isMyLove(user) ? ", meu lovezinho" : ""}: ${shareUrl}`}
                show={showShare}
                handleConfirm={() => {setShowShare(false);}}
            />

            <div className="container container-conta">
                <div className="row justify-content-center">
                    <div className="col-md-8" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
                        <BookOpen size={100} style={{ opacity: .6, marginBottom: 50 }}/>
                        
                        <h2 className="mt-3 text-center">Compartilhar livros</h2>
                        <p className="text-center">Copie o link para compartilhar seus livros: <a href={shareUrl}>{shareUrl}</a></p>

                        <div className="d-flex justify-content-center" style={{ marginTop: '40px', width: '100%' }}>
                            <button onClick={() => { setShowShare(true) }} className="btn-copy-link btn btn-blue">Copiar link</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}